export const SURVEY_ENDPOINTS = Object.freeze({
  LIST: '/surveys',
  CREATE_GENERIC: '/surveys/generic',
  TEMPLATES: '/surveys/templates',
  GET: '/surveys/:id',
  SHARE: '/surveys/:id/share',
  UPDATE_CONTENT: '/surveys/:versionUuid/content',
  PUBLISH: '/surveys/:versionUuid/publish',
  SEND_INVITATIONS: '/surveys/:id/invitations',
  INVITATION_STATUS: '/surveys/:id/invitations/:invitationId',
  PUBLIC_GET: '/public/surveys/:id',
  PUBLIC_SUBMIT: '/public/surveys/:id/responses',
  CLOSE: '/surveys/:id/close',
  PHYSICAL_STRUCTURE: '/surveys/:id/physical-structure',
  EXPORT: '/surveys/:id/responses/export',
  RESPONSE_FILE: '/surveys/:id/responses/:responseId/files/:questionName/:fileIndex',
  METRICS: '/surveys/:id/metrics',
  REPORT: '/surveys/:id/report',
  DELETE: '/surveys/:id',
  API_CONFIG: '/surveys/:id/api-config',
  METADATA: '/surveys/:id/metadata',
  TRIGGER_CONFIG: '/surveys/:id/trigger-config',
  TRIGGER_CONFIG_ITEM: '/surveys/:id/trigger-config/:triggerId',
})
